import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={2450}
        height={7}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox={`0 0 2450 7`}
    >
        <path d="M2448.5 3.542H.5" stroke="#DEDDE2" strokeWidth={2}/>
        <circle cx={2446.5} cy={3.5} r={3.5} fill="#F72585"/>
    </svg>
)

export default SvgComponent
